import { getInstance } from "./index";
import axios from 'axios'

export const authGuardAdmin = (to, from, next) => {
  const authService = getInstance();

  const fn = async () => {
    // If the user is authenticated, continue with the route
    if (authService.isAuthenticated) {

      // Validate vendor and return to login page if not Admin

      // Get the access token from the auth wrapper
      const token = await authService.getTokenSilently();
      // Use Axios to make a call to the API
      const { data } = await axios.get(process.env.VUE_APP_BASE_URL+"/vendors/1", {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      });
      if (data.success==true) {
        return next();
      } else {
        // Otherwise, log in
        authService.loginWithRedirect({ appState: { targetUrl: to.fullPath } });
      }
    }
    // Otherwise, log in (failed auth)
    authService.loginWithRedirect({ appState: { targetUrl: to.fullPath } });
  };

  // If loading has already finished, check our auth state using `fn()`
  if (!authService.loading) {
    return fn();
  }

  // Watch for the loading property to change before we check isAuthenticated
  authService.$watch("loading", loading => {
    if (loading === false) {
      return fn();
    }
  });
};
